import { getHostLocation } from 'owa-url/lib/hostLocation';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';

let isHipErrorHandled: boolean;
export default function checkAndHandleOwaHipError(
    redirectFn: (location: Location, path: string) => void,
    headers?: Headers,
    message: string = ''
): boolean {
    if (headers && headers.get('X-OWA-ExtendedErrorCode') == '5') {
        let hipPath = headers.get('X-OWA-ExtendedErrorData');
        if (!isHipErrorHandled) {
            if (hipPath) {
                isHipErrorHandled = true;
                trace.warn(message);
                logUsage('ReactHipRedirect', { hipPath });
                redirectFn(getHostLocation(), hipPath);
            } else {
                trace.warn('Missing hip redirection url');
            }
        }
    }

    return isHipErrorHandled;
}

export function resetHipErrorHandledFlag() {
    isHipErrorHandled = false;
}
